import { __extends, __values } from "tslib";
import * as React from 'react';
import { ensureEnum, brushToString, stringToBrush, initializePropertiesFromCss, NamePatcher, isValidProp, toSpinal, getModifiedProps } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { ReactRenderer } from "igniteui-react-core";
import { ColumnGrouping } from './ColumnGrouping';
import { BaseControlTheme_$type } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
var IgrColumnGrouping = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrColumnGrouping, _super);
    function IgrColumnGrouping(props) {
        var _this = _super.call(this, props) || this;
        _this._wrapper = null;
        _this._implementation = null;
        _this.__p = null;
        _this._hasUserValues = new Set();
        _this._stylingContainer = null;
        _this._stylingParent = null;
        _this._inStyling = false;
        if (_this._styling) {
            NamePatcher.ensureStylablePatched(Object.getPrototypeOf(_this));
        }
        _this._getMainRef = _this._getMainRef.bind(_this);
        _this._implementation = _this.createImplementation();
        var columnGrouping = _this.i;
        _this._columnGrouping = columnGrouping;
        columnGrouping.notifySizeChanged();
        if (props) {
            _this.initializeProperties();
        }
        return _this;
    }
    Object.defineProperty(IgrColumnGrouping.prototype, "height", {
        get: function () {
            return this._height;
        },
        set: function (value) {
            this._height = value;
            if (this._elRef) {
                this._elRef.style.height = value;
                this._columnGrouping.notifySizeChanged();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "width", {
        get: function () {
            return this._width;
        },
        set: function (value) {
            this._width = value;
            if (this._elRef) {
                this._elRef.style.height = value;
                this._columnGrouping.notifySizeChanged();
            }
        },
        enumerable: false,
        configurable: true
    });
    IgrColumnGrouping.prototype._getMainRef = function (ref) {
        this._elRef = ref;
        if (this._elRef != null) {
            this._renderer = new ReactRenderer(this._elRef, document, false, null);
            this._columnGrouping.provideContainer(this._renderer);
        }
    };
    IgrColumnGrouping.prototype.render = function () {
        var children = [];
        var groupAreaContainer = React.createElement("div", {
            key: "groupAreaContainer"
        });
        children.push(groupAreaContainer);
        var div = React.createElement("div", {
            className: "ig-column-grouping igr-column-grouping",
            ref: this._getMainRef,
            children: children
        });
        return div;
    };
    IgrColumnGrouping.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var e_1, _a;
        var mod = getModifiedProps(this.props, nextProps);
        try {
            for (var _b = __values(Object.keys(mod)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = mod[p];
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return true;
    };
    IgrColumnGrouping.prototype.initializeProperties = function () {
        var e_2, _a;
        try {
            for (var _b = __values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = this.props[p];
                }
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
    };
    // supports angular themes or custom properties set in CSS
    IgrColumnGrouping.prototype.updateStyle = function () {
        this._styling(this._elRef, this);
    };
    IgrColumnGrouping.prototype.componentWillUnmount = function () {
        this._columnGrouping.destroy();
        if (this._renderer) {
            this._renderer.destroy();
        }
    };
    IgrColumnGrouping.prototype.componentDidMount = function () {
        this._elRef.style.width = this._width ? this._width : "";
        this._elRef.style.height = this._height ? this._height : "";
        this._columnGrouping.notifySizeChanged();
        this.initializeContent();
    };
    IgrColumnGrouping.prototype.initializeContent = function () {
        this.updateStyle();
        this.i.notifySizeChanged();
    };
    IgrColumnGrouping.prototype.createImplementation = function () {
        return new ColumnGrouping();
    };
    Object.defineProperty(IgrColumnGrouping.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "targetGrid", {
        /**
     * Gets or Sets the property name that contains the values.
    */
        get: function () {
            if (this.i.targetGrid == null) {
                return null;
            }
            return this.i.targetGrid.externalObject;
        },
        set: function (v) {
            if (v != null && this._stylingContainer && v._styling)
                v._styling(this._stylingContainer, this, this);
            v == null ? this.i.targetGrid = null : this.i.targetGrid = v.i;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "baseTheme", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return this.i.f;
        },
        set: function (v) {
            this.i.f = ensureEnum(BaseControlTheme_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "density", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return this.i.h;
        },
        set: function (v) {
            this.i.h = ensureEnum(ControlDisplayDensity_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "title", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return this.i.ak;
        },
        set: function (v) {
            this.i.ak = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "titleColor", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return brushToString(this.i.bj);
        },
        set: function (v) {
            this.i.bj = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "textStyle", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            if (this.i.k == null) {
                return null;
            }
            return this.i.k.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.k = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "textColor", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return brushToString(this.i.bi);
        },
        set: function (v) {
            this.i.bi = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "iconColor", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return brushToString(this.i.bh);
        },
        set: function (v) {
            this.i.bh = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "backgroundColor", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return brushToString(this.i.bf);
        },
        set: function (v) {
            this.i.bf = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnGrouping.prototype, "hoverBackgroundColor", {
        /**
         * Gets or Sets the property name that contains the values.
        */
        get: function () {
            return brushToString(this.i.bg);
        },
        set: function (v) {
            this.i.bg = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    IgrColumnGrouping.prototype.findByName = function (name) {
        if (this.targetGrid && this.targetGrid.name && this.targetGrid.name == name) {
            return this.targetGrid;
        }
        return null;
    };
    Object.defineProperty(IgrColumnGrouping.prototype, "hasUserValues", {
        get: function () {
            return this._hasUserValues;
        },
        enumerable: false,
        configurable: true
    });
    IgrColumnGrouping.prototype.__m = function (propertyName) {
        if (!this._inStyling) {
            this._hasUserValues.add(propertyName);
        }
    };
    IgrColumnGrouping.prototype._styling = function (container, component, parent) {
        if (this._inStyling) {
            return;
        }
        this._inStyling = true;
        this._stylingContainer = container;
        this._stylingParent = component;
        var genericPrefix = "";
        var typeName = this.i.$type.name;
        if (typeName.indexOf("Xam") === 0) {
            typeName = typeName.substring(3);
        }
        genericPrefix = toSpinal("ColumnGrouping");
        var additionalPrefixes = [];
        var prefix = toSpinal(typeName);
        additionalPrefixes.push(prefix + "-");
        var b = this.i.$type.baseType;
        while (b && b.name != "Object" &&
            b.name != "Base" &&
            b.name != "Control" &&
            b.Name != "DependencyObject" &&
            b.Name != "FrameworkElement") {
            typeName = b.name;
            if (typeName.indexOf("Xam") === 0) {
                typeName = typeName.substring(3);
            }
            var basePrefix = toSpinal(typeName);
            additionalPrefixes.push(basePrefix + "-");
            b = b.baseType;
        }
        if (parent) {
            var parentTypeName = parent.i.$type.name;
            if (parentTypeName.indexOf("Xam") === 0) {
                parentTypeName = parentTypeName.substring(3);
            }
            var parentPrefix = toSpinal(parentTypeName);
            additionalPrefixes.push(parentPrefix + "-" + genericPrefix + "-");
            additionalPrefixes.push(parentPrefix + "-" + prefix + "-");
        }
        initializePropertiesFromCss(container, this, genericPrefix + "-", this.hasUserValues, false, additionalPrefixes);
        if (this.targetGrid && this.targetGrid._styling) {
            this.targetGrid._styling(container, component, this);
        }
        if (this._otherStyling) {
            this._otherStyling(container, component, parent);
        }
        this._inStyling = false;
    };
    /**
 * Exports visual information about the current state of the grid.

*/
    IgrColumnGrouping.prototype.exportVisualModel = function () {
        var iv = this.i.exportVisualModel();
        return (iv);
    };
    /**
     * Returns a serialized copy of the exported visual model
    
    */
    IgrColumnGrouping.prototype.exportSerializedVisualModel = function () {
        var iv = this.i.exportSerializedVisualModel();
        return (iv);
    };
    return IgrColumnGrouping;
}(React.Component));
export { IgrColumnGrouping };
//# sourceMappingURL=igr-column-grouping.js.map
